/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CLog from '../Utility/ComponentLogger';
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** An [[Effect]] for setting the active state of the referenced node(s). */
@cc._decorator.ccclass
export default class ShowNodeEffect extends Effect
{
    /** The referenced node(s). */
    @property({ type: [cc.Node], visible: true })
    private _nodes: cc.Node[] = [];

    /** The value to which their active state should be set. */
    @property({ visible: true })
    private _show: boolean = false;

    /** Indicates if opacity shoudl be set in conjunction with active. */
    @property({ visible: true })
    private _setOpacity: boolean = false;

    /** @hidden */
    protected start(): void
    {
        super.start();

        if (this.reference.Value) { this._nodes.push(this.reference.Value.node); }
    }

    /** Assigns the designated active state to each node. */
    protected trigger = (): void =>
    {
        this._nodes.forEach(node =>
        {
            if (!node)
            {
                CLog.error('Node is null.', this);
                return;
            }
            node.active = this._show;
            if (this._setOpacity)
            {
                node.opacity = this._show ? 255 : 0;
            }
        }, this);
        this.complete();
    }

    /**
     * This effect always executes.
     * @NotImplemented
     */
    public Stop(): void { return; }
}
